const sseFlightArrival = [
    {
        label: 'Basic',
        parameters: [
            {
                label: 'Enabled',
                parameterKey: 'isActive',
                parameterType: 'default',
                inputType: 'switch',
            },
            {
                label: 'Name',
                parameterKey: 'name',
                parameterType: 'default',
                inputType: 'string',
            },
            {
                label: 'Email',
                parameterKey: 'recipients',
                parameterType: 'default',
                inputType: 'multiSelectCreateable',
            },
        ],
    },
    {
        label: 'Flight Arrival Criteria',
        parameters: [
            {
                label: 'Email Alert Title',
                parameterKey: 'alertTitle',
                parameterType: 'default',
                inputType: 'string',
                isRequired: true,
            },
            {
                label: 'Station',
                parameterKey: 'station',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseStation',
                inputType: 'singleSelect',
                isRequired: true,
            },
            {
                label: 'Airline',
                parameterKey: 'carrier',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseAirline',
                inputType: 'multiSelect',
                isRequired: true,
            },
            {
                label: 'Time To Arrival (Minutes)',
                parameterKey: 'timeToArrival',
                parameterType: 'default',
                inputType: 'number',
                min: 0,
                max: 100,
                isRequired: true,
            },
            {
                label: 'Market',
                parameterKey: 'market',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseFlightMarketCode',
                inputType: 'multiSelect',
            },
        ],
    },
];

const sseFlightSlaViolation = [
    {
        label: 'Basic',
        parameters: [
            {
                label: 'Enabled',
                parameterKey: 'isActive',
                parameterType: 'default',
                inputType: 'switch',
            },
            {
                label: 'Name',
                parameterKey: 'name',
                parameterType: 'default',
                inputType: 'string',
            },
            {
                label: 'Email',
                parameterKey: 'recipients',
                parameterType: 'default',
                inputType: 'multiSelectCreateable',
            },
        ],
    },
    {
        label: 'Sla Violation Criteria',
        parameters: [
            {
                label: 'Email Alert Title',
                parameterKey: 'alertTitle',
                parameterType: 'default',
                inputType: 'string',
                isRequired: true,
            },
            {
                label: 'Station',
                parameterKey: 'station',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseStation',
                inputType: 'singleSelect',
                isRequired: true,
            },
            {
                label: 'SLA Violated',
                parameterKey: 'slaViolated',
                parameterType: 'default',
                inputSelectOptionKey: 'slaType',
                inputType: 'singleSelect',
                isRequired: true,
            },
            {
                label: 'Airline',
                parameterKey: 'carrier',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseAirline',
                inputType: 'singleSelect',
            },
            {
                label: 'Market',
                parameterKey: 'market',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseFlightMarketCode',
                inputType: 'singleSelect',
            },
            {
                label: 'Aircraft Body Type',
                parameterKey: 'aircraftBodyType',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseAircraftBodyType',
                inputType: 'singleSelect',
            },
            {
                label: 'Reporting Bag Category',
                parameterKey: 'reportingBagCategory',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseReportingCategory',
                inputType: 'singleSelect',
            },
        ],
    },
];

const sseFlightSlaViolationRepeating = [
    {
        label: 'Basic',
        parameters: [
            {
                label: 'Enabled',
                parameterKey: 'isActive',
                parameterType: 'default',
                inputType: 'switch',
            },
            {
                label: 'Name',
                parameterKey: 'name',
                parameterType: 'default',
                inputType: 'string',
            },
            {
                label: 'Email',
                parameterKey: 'recipients',
                parameterType: 'default',
                inputType: 'multiSelectCreateable',
            },
        ],
    },
    {
        label: 'Sla Violation Repeating Criteria',
        parameters: [
            {
                label: 'Email Alert Title',
                parameterKey: 'alertTitle',
                parameterType: 'default',
                inputType: 'string',
                isRequired: true,
            },
            {
                label: 'Station',
                parameterKey: 'station',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseStation',
                inputType: 'singleSelect',
                isRequired: true,
            },
            {
                label: 'SLA Violated',
                parameterKey: 'slaViolated',
                parameterType: 'default',
                inputSelectOptionKey: 'slaType',
                inputType: 'multiSelect',
                isRequired: true,
            },
            {
                label: 'Airline',
                parameterKey: 'carrier',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseAirline',
                inputType: 'singleSelect',
            },
            {
                label: 'Market',
                parameterKey: 'market',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseFlightMarketCode',
                inputType: 'singleSelect',
            },
            {
                label: 'Aircraft Body Type',
                parameterKey: 'aircraftBodyType',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseAircraftBodyType',
                inputType: 'singleSelect',
            },
            {
                label: 'Reporting Bag Category',
                parameterKey: 'reportingBagCategory',
                parameterType: 'default',
                inputSelectOptionKey: 'dataWarehouseReportingCategory',
                inputType: 'singleSelect',
            },
            {
                label: 'No. Of Violations',
                parameterKey: 'threshold',
                parameterType: 'default',
                inputType: 'number',
                min: 0,
                max: 100,
            },
            {
                label: 'Duration (Within x minutes)',
                parameterKey: 'duration',
                parameterType: 'default',
                inputType: 'number',
                min: 0,
                max: 100,
            },
        ],
    },
];

export default {
    'sse.flightArrival': sseFlightArrival,
    'sse.flightSlaViolation': sseFlightSlaViolation,
    'sse.flightSlaViolationRepeating': sseFlightSlaViolationRepeating,
};
